export default (axios, baseURL) => async (params, clientSid, batchId, status) => {
  const url = `/hub/clients/${encodeURIComponent(clientSid)}/csv/zip/${encodeURIComponent(batchId)}/status`;

  const axiosConfig = {
    method: 'PATCH',
    baseURL,
    url,
    params,
    data: { status }
  };
  const axiosResponse = await axios(axiosConfig);

  if (!axiosResponse || !axiosResponse.data || typeof axiosResponse.data !== 'object') {
    throw new Error('Invalid response from gateway');
  }
  return axiosResponse.data;
};
